import React from 'react';
import { Tooltip } from '../base';
import * as S from './avatar-stack.styles';

interface IAvatarStackProps {
    names?: string[];
    variant?: 'default' | 'messaging';
}

const getInitials = (name: string): string => {
    if (!name) return '';
    
    const parts = name.trim().split(' ');
    if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase();
    }
    
    const firstInitial = parts[0].charAt(0).toUpperCase();
    const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
};

export const AvatarStack: React.FC<IAvatarStackProps> = ({ names, variant = 'default' }) => {
    if (!names || names.length === 0) {
        return <S.EmptyState>—</S.EmptyState>;
    }

    const MAX_VISIBLE = 5;
    const visibleNames = names.slice(0, MAX_VISIBLE);
    const remainingCount = names.length - MAX_VISIBLE;
    const hasMore = remainingCount > 0;

    const isMessaging = variant === 'messaging';
    const avatarSize = isMessaging ? 24 : 32;
    const step = isMessaging ? 12 : 17;
    const totalAvatars = hasMore ? MAX_VISIBLE + 1 : visibleNames.length;
    const containerWidth = totalAvatars * step + (isMessaging ? 12 : 15);

    const Container = isMessaging ? S.MessagingAvatarStackContainer : S.AvatarStackContainer;
    const Wrapper = isMessaging ? S.MessagingAvatarWrapper : S.AvatarWrapper;
    const wrapperProps = { avatarSize, step };

    const renderAvatar = (content: React.ReactNode) =>
        isMessaging ? (
            <S.MessagingAvatar>{content}</S.MessagingAvatar>
        ) : (
            <S.Avatar>{content}</S.Avatar>
        );

    return (
        <Container style={{ width: `${containerWidth}px` }}>
            {visibleNames.map((name, index) => (
                <Wrapper key={`${name}-${index}`} index={index} {...wrapperProps}>
                    <Tooltip direction="top" title={<span>
                                <strong>Assignee:</strong>
                                <br />
                                {name}
                            </span>}>
                        {renderAvatar(getInitials(name))}
                    </Tooltip>
                </Wrapper>
            ))}
            {hasMore && (
                <Wrapper index={MAX_VISIBLE} {...wrapperProps}>
                    <Tooltip direction="top" title={<span>
                                <strong>Assignee:</strong> 
                                {names.slice(MAX_VISIBLE).join(', ')}
                            </span>}>
                        {renderAvatar(`+${remainingCount}`)}
                    </Tooltip>
                </Wrapper>
            )}
        </Container>
    );
};

